import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import RebalancingRuleList from '../rebalancingRules/RebalancingRuleList';
import { usePortfolioRebalancingRulesSuspenseQuery } from 'generated/graphql';

const PortfolioRebalancingRuleList = (): ReactElement => {
  const { portfolioDefinitionId } = useParams();
  if (!portfolioDefinitionId) {
    throw new Error('Missing portfolio definition');
  }

  const { data } = usePortfolioRebalancingRulesSuspenseQuery({
    variables: {
      id: portfolioDefinitionId,
    },
  });

  return (
    <RebalancingRuleList
      rebalancingRules={data.portfolio.definition.rebalancedDetails?.rebalancingRules ?? []}
      createNewRuleUrl={`/app/copilot/lab/portfolio/${portfolioDefinitionId}/rebalancing-rules/new`}
    />
  );
};

export default PortfolioRebalancingRuleList;
